import { Button, HStack, useDisclosure } from '@chakra-ui/react';
import { useState } from 'react';
import { FaSliders } from 'react-icons/fa6';
import { LoadingStt } from '../pages/ContractsPage';
import ContractsFilterModal from './ContractsFilterModal';

export type contractFilter = {
  periodicity: 'all' | 'monthly' | 'yearly';
  status: 0 | 1 | null;
  includeDeleted: boolean;
  service?: number;
  startDate?: string;
  endDate?: string;
};
interface ContractsListFiltersProps {
  onFilterChange: (filter: contractFilter) => void;
  loading: LoadingStt;
}
const ContractsListFilters = ({
  onFilterChange,
  loading,
}: ContractsListFiltersProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentFilter, setCurrentFilter] = useState<contractFilter>({
    periodicity: 'all',
    status: null,
    includeDeleted: true,
  });

  const handlePeriodicityChange = (newFilter: 'all' | 'monthly' | 'yearly') => {
    const updated = { ...currentFilter, periodicity: newFilter };
    setCurrentFilter(updated);
    onFilterChange(updated);
  };

  const handleModalApply = (filter: contractFilter) => {
    setCurrentFilter(filter);
    onFilterChange(filter);
  };

  const hasActiveModalFilters =
    currentFilter.status !== null ||
    !currentFilter.includeDeleted ||
    currentFilter.service !== undefined ||
    currentFilter.startDate !== undefined ||
    currentFilter.endDate !== undefined;

  return (
    <>
      <HStack w="100%" gap="16px" justifyContent="flex-end">
        <Button
          variant="stroke"
          onClick={() => handlePeriodicityChange('all')}
          colorScheme={currentFilter.periodicity === 'all' ? 'selected' : ''}
          isDisabled={loading.stt}
        >
          Todos
        </Button>
        <Button
          variant="stroke"
          onClick={() => handlePeriodicityChange('yearly')}
          colorScheme={currentFilter.periodicity === 'yearly' ? 'selected' : ''}
          isDisabled={loading.stt}
        >
          Anual
        </Button>
        <Button
          variant="stroke"
          onClick={() => handlePeriodicityChange('monthly')}
          colorScheme={
            currentFilter.periodicity === 'monthly' ? 'selected' : ''
          }
          isDisabled={loading.stt}
        >
          Mensal
        </Button>
        <Button
          variant="stroke"
          leftIcon={<FaSliders />}
          colorScheme={hasActiveModalFilters ? 'selected' : ''}
          onClick={onOpen}
          isDisabled={loading.stt}
        >
          Filtrar
        </Button>
      </HStack>

      <ContractsFilterModal
        isOpen={isOpen}
        onClose={onClose}
        onApply={handleModalApply}
        currentFilter={currentFilter}
      />
    </>
  );
};
export default ContractsListFilters;
